import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import NcButton from '@nextcloud/vue/components/NcButton';
import UploadIcon from 'vue-material-design-icons/CloudUpload.vue';

import { t } from '@services/l10n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadMenuItem',
  setup(__props) {

function upload() {
  _m.modals.upload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcButton), {
    class: "memories-menu-item upload-menu",
    variant: "tertiary-no-background",
    title: _unref(t)('memories', 'Upload'),
    "aria-label": _unref(t)('memories', 'Upload'),
    onClick: upload
  }, {
    icon: _withCtx(() => [
      _createVNode(UploadIcon, { size: 20 })
    ]),
    _: 1
  }, 8, ["title", "aria-label"]))
}
}

})